/**
 * Módulo: Timeline Modal - Histórico Cronológico
 * Arquivo: js/pages/suprimentos/estoque/timeline-modal.js
 * 
 * Exibe histórico completo de movimentações em ordem cronológica
 * Com evolução de saldo e custo médio
 */

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Estoque = window.FazendaRP.Estoque || {};
window.FazendaRP.Estoque.TimelineModal = {

    /**
     * Renderiza modal de timeline
     */
    render: function () {
        if (document.getElementById('modal-timeline-estoque')) return;

        const modal = document.createElement('div');
        modal.id = 'modal-timeline-estoque';
        modal.style.cssText = "display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 2200; justify-content: center; align-items: center;";
        modal.innerHTML = `
            <div style="background: white; padding: 0; border-radius: 12px; width: 90%; max-width: 900px; height: 85vh; display: flex; flex-direction: column; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,0.3);">
                <div style="padding: 24px; border-bottom: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center; background: #f9fafb;">
                    <h2 id="timeline-title" style="margin: 0; font-size: 1.3rem; color: #111827; font-weight: 600;">📅 Timeline Cronológica</h2>
                    <button onclick="window.FazendaRP.Estoque.TimelineModal.close()" style="border:none; background:transparent; font-size:1.5rem; cursor:pointer; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: all 0.2s; color: #9ca3af;">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div id="timeline-content" style="flex: 1; overflow-y: auto; padding: 24px; background: #fff;">
                    <div style="text-align: center; padding: 40px; color: #9ca3af;">
                        <i class="fas fa-spinner fa-spin fa-2x"></i>
                        <p style="margin-top: 16px;">Carregando histórico...</p>
                    </div>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        // Click fora fecha
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                this.close();
            }
        });
    },

    /**
     * Abre modal para um item
     */
    open: async function (estoqueId) {
        this.render();

        const modal = document.getElementById('modal-timeline-estoque');
        if (!modal) return;

        // Buscar dados do item
        const { data: estoque } = await window.FazendaRP.supabase
            .from('suprimentos_estoque')
            .select('*')
            .eq('id', estoqueId)
            .single();

        if (!estoque) {
            alert('Item não encontrado');
            return;
        }

        // Atualizar título
        const titleEl = document.getElementById('timeline-title');
        if (titleEl) titleEl.innerHTML = `📅 Timeline: <strong>${estoque.item_nome}</strong>`;

        // Mostrar modal
        modal.style.display = 'flex';

        // Carregar histórico
        await this.loadTimeline(estoqueId, estoque);
    },

    /**
     * Carrega e renderiza timeline
     */
    loadTimeline: async function (estoqueId, estoque) {
        const content = document.getElementById('timeline-content');
        if (!content) return;

        try {
            // Buscar movimentações
            const { data: movs, error } = await window.FazendaRP.supabase
                .from('suprimentos_movimentacoes')
                .select('*')
                .eq('estoque_id', estoqueId)
                .order('data_movimentacao', { ascending: false })
                .order('created_at', { ascending: false });

            if (error) throw error;

            if (!movs || movs.length === 0) {
                content.innerHTML = `
                    <div style="text-align: center; padding: 60px 20px; color: #9ca3af;">
                        <i class="fas fa-inbox fa-3x" style="margin-bottom: 16px;"></i>
                        <p style="font-size: 1.1rem; font-weight: 500;">Nenhuma movimentação encontrada</p>
                        <p style="font-size: 0.9rem; margin-top: 8px;">Este item ainda não teve entradas ou saídas</p>
                    </div>
                `;
                return;
            }

            // Renderizar timeline
            let html = '<div style="position: relative;">';

            // NEW: Calculate running balance simulation if needed, or use snapshot if available.
            // Reconciliation.js actually calculates simulation in memory, but here we are fetching raw rows.
            // Ideally, we should fetch the computed timeline from Reconciliation service, OR calculate here.
            // Since this display is critical, let's QUICKLY calculate the "Saldo Após" here for display purposes.
            // NOTE: We fetched descending order. It's easier to calculate ASCENDING then reverse.

            // Sort ascending for calculation
            movs.sort((a, b) => {
                // 1. Data Movimentação
                const dateA = new Date(a.data_movimentacao);
                const dateB = new Date(b.data_movimentacao);
                if (dateA - dateB !== 0) return dateA - dateB;

                // 2. Prioridade: ENTRADA antes de SAÍDA (evita saldo negativo transiente)
                if (a.tipo === 'ENTRADA' && b.tipo !== 'ENTRADA') return -1;
                if (a.tipo !== 'ENTRADA' && b.tipo === 'ENTRADA') return 1;

                // 3. Created At (Tie-breaker final)
                return new Date(a.created_at) - new Date(b.created_at);
            });

            let saldoSimulado = 0;
            let custoMedioSimulado = 0; // Simplified for display if needed, but we rely on stored/calc data

            // Add computed properties
            const movsWithBalance = movs.map(m => {
                const qtd = parseFloat(m.quantidade);
                const cost = parseFloat(m.custo_unitario || 0); // Not always stored for exits

                // Simple Calc Logic (Shared with Calculator.js essentially)
                if (m.tipo === 'ENTRADA') {
                    // Recalc Avg Cost
                    if (saldoSimulado <= 0) custoMedioSimulado = cost;
                    else custoMedioSimulado = ((saldoSimulado * custoMedioSimulado) + (qtd * cost)) / (saldoSimulado + qtd);

                    saldoSimulado += qtd;
                } else {
                    saldoSimulado -= qtd;
                }

                return { ...m, saldoApos: saldoSimulado, custoMedioNoMomento: custoMedioSimulado };
            });

            // Reverse back to Descending for Display
            movsWithBalance.reverse();


            movsWithBalance.forEach((mov, index) => {
                const isEntrada = mov.tipo === 'ENTRADA';

                // Colors
                const colorMain = isEntrada ? '#10b981' : '#ef4444'; // Green / Red
                const bgHeader = isEntrada ? '#f0fdf4' : '#fef2f2'; // Light Green / Red
                const icon = isEntrada ? 'plus' : 'minus';

                // Dates
                let date = '-';
                let time = '';
                if (mov.data_movimentacao) {
                    try {
                        const [year, month, day] = mov.data_movimentacao.split('T')[0].split('-');
                        date = `${day}/${month}/${year}`;
                    } catch (e) { }
                }
                if (mov.created_at) {
                    try { time = new Date(mov.created_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); } catch (e) { }
                }

                // Metadata Extraction
                const obs = mov.observacao || '';
                let origemTitle = 'Origem Desconhecida';
                let origemSub = '';

                if (mov.origem_tipo === 'COMPRA') {
                    origemTitle = `NFe Entrada`;
                    // Try extract Provider
                    if (obs.includes('(')) {
                        // "Importado via NFe 123 (Fornecedor)"
                        const match = obs.match(/\((.*?)\)/);
                        if (match) origemSub = `Fornecedor: ${match[1]}`;
                    } else {
                        origemSub = `Origem: COMPRA`;
                    }
                } else if (mov.origem_tipo === 'ABASTECIMENTO') {
                    origemTitle = `Abastecimento`;
                    // "Abastecimento Máquina: Trator (...)"
                    if (obs.includes('Máquina:')) {
                        origemSub = obs.split('Máquina:')[1].trim();
                    } else {
                        origemSub = 'Máquina: Não identificada';
                    }
                } else if (mov.origem_tipo === 'MANUAL') {
                    origemTitle = `Ajuste Manual`;
                    origemSub = `Motivo: ${obs}`;
                } else {
                    origemTitle = mov.origem_tipo;
                    origemSub = obs;
                }

                // Values
                const qtdVal = Math.abs(parseFloat(mov.quantidade));
                const custoMedioDisplay = mov.custoMedioNoMomento || 0;
                const saldoAposDisplay = mov.saldoApos || 0;
                const valorTotalMov = qtdVal * (isEntrada ? (mov.custo_unitario || 0) : custoMedioDisplay);

                // HTML CONSTRUCTION
                html += `
                    <div style="display: flex; gap: 15px; margin-bottom: 25px;">
                        
                        <!-- Timeline Icon Column -->
                        <div style="display: flex; flex-direction: column; align-items: center; min-width: 40px;">
                            <div style="width: 36px; height: 36px; border-radius: 50%; background: ${colorMain}; color: white; display: flex; align-items: center; justify-content: center; font-size: 1rem; box-shadow: 0 4px 6px -1px ${colorMain}40; z-index: 2;">
                                <i class="fas fa-${icon}"></i>
                            </div>
                            <!-- Line -->
                            ${index !== movsWithBalance.length - 1 ? `<div style="width: 2px; flex: 1; background: #e5e7eb; margin-top: 5px; margin-bottom: 5px;"></div>` : ''}
                        </div>

                        <!-- Card Content -->
                        <div style="flex: 1; background: #fff; border-radius: 8px; border-left: 4px solid ${colorMain}; box-shadow: 0 1px 3px rgba(0,0,0,0.1); overflow: hidden;">
                            
                            <!-- Header -->
                            <div style="padding: 15px 20px; border-bottom: 1px solid #f3f4f6; background: ${bgHeader}; display: flex; justify-content: space-between; align-items: start;">
                                <div>
                                    <h4 style="margin: 0; font-size: 1rem; color: #1f2937; font-weight: 700;">
                                        <i class="fas fa-circle" style="font-size: 0.6rem; color: ${colorMain}; margin-right: 8px; vertical-align: middle;"></i>
                                        ${mov.tipo} - ${origemTitle}
                                    </h4>
                                    <div style="font-size: 0.8rem; color: #6b7280; margin-top: 4px;">${origemSub}</div>
                                </div>
                                <div style="font-size: 1.1rem; font-weight: 800; color: ${colorMain};">
                                    ${isEntrada ? '+' : '-'}${qtdVal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} ${estoque.unidade}
                                </div>
                            </div>

                            <!-- Grid Info -->
                            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; padding: 15px 20px;">
                                
                                <!-- Col 1 -->
                                <div>
                                    <div style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; margin-bottom: 2px;">
                                        💰 Custo Médio
                                    </div>
                                    <div style="font-size: 0.95rem; color: #374151; font-weight: 600;">
                                        ${custoMedioDisplay.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </div>
                                </div>

                                <!-- Col 2 -->
                                <div>
                                    <div style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; margin-bottom: 2px;">
                                        📊 Saldo Após
                                    </div>
                                    <div style="font-size: 0.95rem; color: #374151; font-weight: 600;">
                                        ${saldoAposDisplay.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} ${estoque.unidade}
                                    </div>
                                </div>

                                <!-- Col 3 -->
                                <div>
                                    <div style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase; margin-bottom: 2px;">
                                        ${isEntrada ? '💲 Custo Entrada' : '⏱️ Ref / Horímetro'}
                                    </div>
                                    <div style="font-size: 0.95rem; color: #374151; font-weight: 600;">
                                        ${isEntrada
                        ? (mov.custo_unitario || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + '/' + estoque.unidade
                        : '-'}
                                    </div>
                                </div>

                                <!-- Col 4 -->
                                <div>
                                    <div style="font-size: 0.7rem; color: #5b21b6; font-weight: 600; text-transform: uppercase; margin-bottom: 2px;">
                                        💎 Valor Total Mov.
                                    </div>
                                    <div style="font-size: 0.95rem; color: #5b21b6; font-weight: 700;">
                                        ${valorTotalMov.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </div>
                                </div>

                            </div>

                            <!-- Footer -->
                            <div style="padding: 10px 20px; background: #f9fafb; border-top: 1px solid #f3f4f6; display: flex; justify-content: space-between; align-items: center;">
                                <div style="font-size: 0.8rem; color: #6b7280; font-style: italic; max-width: 70%;">
                                    "${obs}"
                                </div>
                                <div style="font-size: 0.8rem; color: #9ca3af; display: flex; align-items: center; gap: 5px;">
                                    <i class="far fa-calendar-alt"></i> ${date} • ${time}
                                </div>
                            </div>
                            
                           <!-- Delete (Only Manual) -->
                            ${(mov.origem_tipo === 'MANUAL' || mov.origem_tipo === 'USUARIO') ? `
                                <div style="padding: 0 20px 15px; text-align: right;">
                                     <button onclick="window.FazendaRP.Estoque.TimelineModal.deleteMovement('${mov.id}', '${estoqueId}')" style="background: white; border: 1px solid #fee2e2; color: #ef4444; font-size: 0.75rem; padding: 4px 10px; border-radius: 4px; cursor: pointer;">
                                        <i class="fas fa-trash"></i> Excluir
                                     </button>
                                </div>
                            ` : ''}

                        </div>
                    </div>
                    `;
            });

            html += '</div>';

            // Adicionar nota educativa sobre custo médio
            html += `
                <div style="background: #fef3c7; border-left: 4px solid #f59e0b; padding: 16px; border-radius: 8px; margin-top: 24px;">
                    <div style="display: flex; align-items: start; gap: 12px;">
                        <i class="fas fa-info-circle" style="color: #92400e; font-size: 1.2rem; margin-top: 2px;"></i>
                        <div>
                            <strong style="color: #92400e; display: block; margin-bottom: 8px;">💡 Sobre Custo Médio</strong>
                            <p style="margin: 4px 0; color: #78350f; font-size: 0.85rem;">
                                • Quando <strong>estoque zera</strong>, o custo médio é <strong>resetado</strong><br>
                                • Na próxima entrada, o custo médio <strong>reinicia</strong> com o custo da nova compra<br>
                                • Isso evita que custos antigos distorçam o valor atual do estoque
                            </p>
                        </div>
                    </div>
                </div>
            `;

            content.innerHTML = html;

        } catch (err) {
            content.innerHTML = `<div style="color:red; text-align:center; padding:40px;">Erro: ${err.message}</div>`;
        }
    },

    /**
     * Deleta movimentação manual
     */
    deleteMovement: async function (movimentacaoId, estoqueId) {
        if (!confirm('Tem certeza que deseja excluir esta movimentação manual?\n\nO estoque será recalculado automaticamente.')) {
            return;
        }

        try {
            const result = await window.FazendaRP.Estoque.deletarMovimentacao(movimentacaoId, estoqueId);

            if (result.success) {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Movimentação excluída e estoque recalculado!');
                // Recarregar timeline
                const { data: estoque } = await window.FazendaRP.supabase
                    .from('suprimentos_estoque')
                    .select('*')
                    .eq('id', estoqueId)
                    .single();

                await this.loadTimeline(estoqueId, estoque);

                // Recarregar tabela principal em background
                if (window.FazendaRP.Pages.suprimentos.estoque.loadEstoque) {
                    window.FazendaRP.Pages.suprimentos.estoque.loadEstoque();
                }
            }

        } catch (err) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao excluir: ' + err.message);
        }
    },

    /**
     * Fecha modal
     */
    close: function () {
        const modal = document.getElementById('modal-timeline-estoque');
        if (modal) modal.style.display = 'none';
    }
};

console.log('✅ Timeline Modal carregado');
